<hr-glass-distortion />
<div class="main-container">
  <div class="chat-bg">
    @if (activeFeature(); as feature) {
      <ng-container
        [ngComponentOutlet]="feature.activateCmp"
        [ngComponentOutletInputs]="activeFeatureInputs()"
      />
    } @else {
      @let messages = threads()[currentThreadId()];
      @let contextExpandedMapVal = contextExpandedMap();
      @let hasMessages = $safeNavigationMigration(messages?.()?.length);
      @if (hasMessages) {
        <tlc-chat-header-thread (back)="onNewThread()" (close)="onClose()" />
        <div #messagesContainer class="messages-container">
          @for (message of messages(); track $index) {
            @let messageVal = message();
            @let isUser = messageVal.role === 'user';
            @let isAssistant = messageVal.role === 'assistant';
            <div class="item">
              <div
                class="message"
                [ngClass]="[messageVal.role]"
                [class.component]="messageVal.isComponent"
              >
                @if (messageVal.isPending && isAssistant) {
                  <div class="message--container">
                    <p class="message--text shimmer">
                      {{ 'tlc.hr_assistant.searching_placeholder' | translate }}
                    </p>
                  </div>
                } @else {
                  @if (isUser) {
                    <rt-avatar
                      class="message--icon"
                      [type]="userAvatar() ? 'image' : 'initials'"
                      [imageSrc]="userAvatar()"
                      [initials]="userInitials()"
                      [fullName]="userFullName()"
                    />
                  } @else if (isAssistant) {
                    <hr-assistant-icon class="message--icon" [size]="32" />
                  }
                  <div class="message--container">
                    <p
                      class="message--text"
                      [innerHtml]="trustHtml | fnCall: messageVal.content"
                    ></p>
                    @if (isAssistant) {
                      @let contexts =
                        getToolInvocationResultText | fnCall: messageVal.toolInvocations;
                      @let contextsExpanded = !!contextExpandedMapVal[messageVal.id];
                      @let visibleContexts =
                        contextsExpanded
                          ? contexts
                          : (contexts | slice: 0 : DEFAULT_MESSAGE_CONTEXT_COUNT);
                      @for (context of visibleContexts; track $index) {
                        <ng-template #tooltipTmpl>
                          <span
                            class="context--quote"
                            [innerHtml]="markdownToHtml | fnCall: context.text"
                          ></span>
                        </ng-template>
                        <div
                          class="context"
                          rtTooltip
                          [rtTooltipTemplate]="tooltipTmpl"
                          [rtTooltipMaxWidth]="381"
                        >
                          <a class="context--source" [href]="context.url" target="_blank">
                            <rt-icon [name]="context.icon" margin-right-small />
                            <rt-truncate class="truncate">{{ context.title }}</rt-truncate>
                            <rt-icon-button
                              iconName="open-in-new"
                              size="small-x"
                              variant="plain"
                              margin-left-small-x
                            />
                          </a>
                        </div>
                      }
                      @if (contexts.length > DEFAULT_MESSAGE_CONTEXT_COUNT) {
                        <rt-button
                          size="small"
                          variant="plain"
                          (click)="toggleExpandContext(messageVal.id)"
                          class="context-toggle"
                          margin-top-small
                        >
                          {{
                            (contextExpandedMapVal[messageVal.id]
                              ? 'tlc.hr_assistant.show_less'
                              : `tlc.hr_assistant.show_all_x`
                            )
                              | translate
                                : {
                                    remainingCount: contexts.length - DEFAULT_MESSAGE_CONTEXT_COUNT,
                                  }
                          }}
                        </rt-button>
                      }
                      <thumb-up-down-feedback
                        class="actions"
                        (feedbackChange)="onFeedback($event)"
                      />
                    }
                  </div>
                }
              </div>
              @if (messageVal.isError) {
                <rt-infobox
                  type="error"
                  iconName="error"
                  [isDismissible]="false"
                  [buttons]="getMessageErrorButtons | fnCall: messageVal"
                  margin-top-medium
                >
                  @if (messageVal.errorMessage) {
                    <span [innerHtml]="trustHtml | fnCall: messageVal.errorMessage"></span>
                  } @else {
                    <span>{{ 'tlc.hr_assistant.generic_error_msg' | translate }}</span>
                  }
                </rt-infobox>
              }
            </div>
          }
        </div>
      } @else {
        <tlc-header-welcome (close)="onClose()" />
        <div class="welcome-container">
          <rt-heading variant="heading large-x-dialog-header">
            {{ 'tlc.hr_assistant.hey_first_name' | translate: { firstName: firstName() } }}
          </rt-heading>
          <p class="description" margin-top-small-xx margin-bottom-medium text-color>
            {{ greeting() }}
          </p>
          <div class="features" padding-bottom>
            @for (feature of availableFeatures(); track feature.id) {
              <div class="feature" (click)="onFeatureClick(feature)">
                <ng-container [rtComponentOutlet]="feature.welcomeCmp" />
              </div>
            }
          </div>

          @if (conversationStarters().length && wikiEnabled()) {
            <div>
              <rt-heading>
                {{ 'tlc.hr_assistant.conversation_starters' | translate }}
              </rt-heading>
              <div class="starters">
                @for (starter of conversationStarters(); track $index) {
                  <div class="starter" (click)="onStarterClick(starter.content)">
                    @if (starter.symbol) {
                      <rt-symbol [symbol]="starter.symbol" text-primary margin-right-small-x />
                    }
                    {{ starter.content }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (wikiEnabled()) {
        <rt-divider />
        <div class="footer">
          <div class="text-area">
            <rt-textarea
              #chatInput
              [formControl]="chatForm"
              [placeholder]="'tlc.hr_assistant.input_placeholder' | translate"
              [maxHeight]="96"
              [autoHeight]="true"
              (keyup.enter)="onSend()"
            />
            <div class="buttons">
              <rt-icon-button
                (click)="canSendMessage() && onSend()"
                [disabled]="!canSendMessage()"
                class="send-button"
                iconName="arrow-upward"
                size="small"
                variant="primary"
              />
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
